import { useState } from 'react';
import VisibilitySensor from 'react-visibility-sensor';
import CountUp from 'react-countup';
import { LuCupSoda } from 'react-icons/lu';
import { TbDeviceDesktopCode, TbWorldCode, TbClockCode } from 'react-icons/tb';
import '../assets/style/counterup.scss';

const CounterUp = () => {
  const [isVisible, setIsVisible] = useState(false);

  const onVisibilityChange = (isVisible) => {
    if (isVisible) {
      setIsVisible(true);
    }
  };

  return (
    <div id="counterup-stats" className="counterup-wrapper">
      {/* <h1 className="counterup-wrapper--h1">My journey so far...</h1> */}
      <h1 className="counterup-wrapper--h1">
        My journey so far...
      </h1>
      {/* <div className="counterup-wrapper--inner"> */}
      <div className="counterup-wrapper--container">
        <div className="counterup-row">
          <div>
            <div className="counter">
              <i className="fa fa-code fa-2x stats-icon"><TbWorldCode /></i>
              <VisibilitySensor onChange={onVisibilityChange} partialVisibility>
                <h2 className="timer count-title count-number">
                  <CountUp start={0} end={isVisible ? 100 : 0} duration={6} delay={4} />
                  +
                </h2>
              </VisibilitySensor>

              <div className="stats-line-black" />
              <p className="stats-text">Projects delivered</p>
            </div>
          </div>
          <div>
            <div className="counter">
              <i className="fa fa-code fa-2x stats-icon"><TbClockCode /></i>
              <VisibilitySensor onChange={onVisibilityChange} partialVisibility>
                <h2 className="timer count-title count-number">
                  <CountUp start={0} end={isVisible ? 2 : 0} duration={6} delay={4} />
                  +
                </h2>
              </VisibilitySensor>
              <div className="stats-line-black" />
              <p className="stats-text">Years of Experience</p>
            </div>
          </div>
          <div>
            <div className="counter">
              <i className="fa fa-code fa-2x stats-icon"><TbDeviceDesktopCode /></i>
              <VisibilitySensor onChange={onVisibilityChange} partialVisibility>
                <h2 className="timer count-title count-number">
                  <CountUp start={0} end={isVisible ? 10000 : 0} duration={6} delay={4} />
                  +
                </h2>
              </VisibilitySensor>
              <div className="stats-line-black" />
              <p className="stats-text">Lines of Code</p>
            </div>
          </div>
          <div>
            <div className="counter">
              <i className="fa fa-code fa-2x stats-icon"><LuCupSoda /></i>
              <VisibilitySensor onChange={onVisibilityChange} partialVisibility>
                <h2 className="timer count-title count-number">
                  <CountUp start={0} end={isVisible ? 999 : 0} duration={6} delay={4} />
                  +
                </h2>
              </VisibilitySensor>
              <div className="stats-line-black" />
              <p className="stats-text">Soda Drinks</p>
            </div>
          </div>
        </div>
      </div>
      {/* </div> */}
    </div>
  );
};

export default CounterUp;
